module.exports = __webpack_public_path__ + "static/media/google-text-logo.cc4ce17a.png";